/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Full_Bumblebee_FetchInputs */

const en_keen_full_bumblebee_fetch = /** @type {(inputs: Keen_Full_Bumblebee_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding automation...`)
};

const de_keen_full_bumblebee_fetch = /** @type {(inputs: Keen_Full_Bumblebee_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierung wird hinzugefügt...`)
};

/**
* | output |
* | --- |
* | "Adding automation..." |
*
* @param {Keen_Full_Bumblebee_FetchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_full_bumblebee_fetch = /** @type {((inputs?: Keen_Full_Bumblebee_FetchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Full_Bumblebee_FetchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_full_bumblebee_fetch(inputs)
	return de_keen_full_bumblebee_fetch(inputs)
});